import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import { Site } from 'four-nets/site';
import Avatar from 'four-nets/avatar/avatar';
import photo from 'four-nets/icons/svg/icon_photo.svg';
import heart from 'four-nets/icons/svg/icon_heart.svg';
import heartFull from 'four-nets/icons/svg/icon_heart-full.svg';
import activity from 'four-nets/icons/svg/icon_activity2.svg';
import HighlightedBadge from 'four-nets/ui-v2/badges/highlighted-badge/highlighted-badge';
import Badge from 'four-nets/ui-v2/badges/badge/badge';
import { displayedName } from 'four-nets/user/utils';

import { CollectionInfoFragment } from './collection-info.graphql';
import defaultStyles from './collection-info.scss';


export interface Props extends CollectionInfoFragment {
    styles: typeof defaultStyles;
}

class CollectionInfo extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    render() {
        const { styles, isNew, ...collection } = this.props;
        const user = collection.photoblog.user;

        return (
            <div className={styles.info}>
                <HighlightedBadge>
                    <Link to='/blogs/collections/' className={styles.link}>
                        <FormattedMessage id='COLLECTION' />
                    </Link>
                </HighlightedBadge>
                {isNew ? (
                    <HighlightedBadge>
                        <FormattedMessage id='NEW' />
                    </HighlightedBadge>
                ) : null}
                <Badge>
                    <>
                        <SVGIcon style={{ image: styles.infoIcon }} src={activity} />
                        <FormattedDateAgoView value={new Date(collection.createdOn)} />
                    </>
                </Badge>
                <Badge>
                    <>
                        <Avatar style={{avatar: styles.avatar}} user={user} />
                        <Link
                            to={
                                user && user.profile && user.profile.isVendor
                                    ? `/catalog/vendor/${user && user.username}`
                                    : `/blog/${user && user.username}`
                            }
                            className={styles.link}
                        >
                            {collection.photoblog.user && displayedName(collection.photoblog.user)}
                        </Link>
                    </>
                </Badge>
                <Badge>
                    <>
                        <SVGIcon style={{ image: styles.infoIcon }} src={photo} />
                        {collection.imagesCount}
                    </>
                </Badge>
                <Badge>
                    <>
                        <SVGIcon
                            style={{ image: styles.likedIcon }}
                            src={collection.isLikedByViewer ? heartFull : heart}
                            className={collection.isLikedByViewer ? styles.likedIcon : undefined}
                        />
                        {collection.likesCount}
                    </>
                </Badge>
            </div>
        );
    }
}

export default Styled(defaultStyles)(CollectionInfo);
